import { Box, DialogActions, DialogContent, Divider, Grid } from "@mui/material";
import { ReactComponent as ArrowDown } from "assets/ArrowDown.svg";
import { ReactComponent as ArrowUp } from "assets/ArrowUp.svg";
import { ReactComponent as UserCircle } from "assets/UserCircle.svg";
import { ReactComponent as Article } from "assets/article.svg";
import ThemeContext from "components/app/Context";
import Button from "components/common/Button";
import { assignMultiplePlans } from "components/features/AboveProperty/AboveProperty.slice";
import { assignPlanstoInncode } from "components/features/SME/home/sme.slice";
import { useTranslate } from "hooks/useTranslate";
import { useContext, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { messages, sourceValues } from "utils/CommonConstants";
import { responseTypes } from "utils/Types";
import BackButton from "../BackButton";
import DialogFormation from "../DialogFormation";
import Feedback from "../Feedback";
import HTMLRenderer from "../HTMLRenderer";
import RichText from "../RichText";
import Typography from "../Typography";
import Calender from "../calender/Calender";
import "./index.scss";
interface Prop {
  selectedList: any;
  selectedPlan?: any;
  SelectedPlansList?: any;
  handleCloseState: React.Dispatch<React.SetStateAction<boolean>>;
  handleBackState: React.Dispatch<React.SetStateAction<any>>;
  selectedInnCodeGroup?: any;
  innCode?: any;
  listId?: number;
  onCloseConfirm: () => void;
  isTemplatePlan?: boolean;
  flowSpecificPayload?: any;
}
export default function AssignPlanConfirmDialogs(props: Prop) {
  const translate = useTranslate();
  const [openDialog, setOpenDialog] = useState<any>({
    openMessageDialog: true,
    openconfirmDialog: false,
    openCompletedDialog: false
  });
  const [message, setMessage] = useState("");
  const dispatch = useAppDispatch();
  const {
    selectedList,
    handleCloseState,
    handleBackState,
    selectedInnCodeGroup,
    innCode,
    SelectedPlansList,
    onCloseConfirm,
    isTemplatePlan = false,
    flowSpecificPayload = {}
  } = props;
  const { ad: users } = useAppSelector((state) => state.myPlanDetails);
  const { users: smeUsers }: any = useAppSelector((state) => state.sme);
  const { isAbovePropertyUser } = useAppSelector((state) => state.app);
  const [plansList, setPlansList] = useState(SelectedPlansList);
  const { isMobileScreen } = useContext(ThemeContext);
  const [isSeeAll, setIsSeeAll] = useState<boolean>(false);

  const handleCloseDialog = () => {
    handleCloseState(false);
    onCloseConfirm();
  };

  const getAbovePropertyPayload = () => {
    const payLoadData = {
      inncodeUsers: selectedList?.map((item: any) => {
        return { inncode: item?.innCode || item?.innCodes?.[0], hltId: item.hltId };
      }),
      [isTemplatePlan ? "templatePlans" : "libraryPlans"]: plansList?.map((plan: any) => {
        return { id: plan?.id, title: plan?.name, dueDate: plan?.dueDate ? plan.dueDate : null };
      }),
      message: message,
      source: "management_assigned"
    };

    const url = {
      inncode: flowSpecificPayload?.innCode ? flowSpecificPayload?.innCode : innCode,
      isBulkAssignment: flowSpecificPayload?.isBulkAssignment
    };
    return { url, payLoadData };
  };
  const handleAssignPlan = async () => {
    const payload = {
      libraryPlans: plansList?.map((plan: any) => {
        return { id: plan?.id, title: plan?.name, dueDate: plan?.dueDate ? plan.dueDate : null };
      }),
      mappingIds: selectedList?.map((item: any) => item?.id) || [],
      message: message,
      source: sourceValues.assignedSme
    };
    const url = {
      inncode: flowSpecificPayload?.innCode ? flowSpecificPayload?.innCode : innCode,
      isBulkAssignment: flowSpecificPayload?.isBulkAssignment
    };
    const response = isAbovePropertyUser
      ? await dispatch(assignMultiplePlans(getAbovePropertyPayload()))
      : await dispatch(assignPlanstoInncode({ url, payload }));

    if (response?.payload?.status === responseTypes.accepted) {
      setOpenDialog({
        openMessageDialog: false,
        openconfirmDialog: false,
        openCompletedDialog: true
      });
    }
  };
  const addDueDate = (id: any, date: any) => {
    if (plansList) {
      const data: any = plansList?.map((plan: any) => {
        if (id === plan.id) return { ...plan, dueDate: date };
        return plan;
      });
      setPlansList(data);
    }
  };

  const handleCollapse = () => {
    setIsSeeAll(!isSeeAll);
  };

  return (
    <>
      <Feedback form={"assignPlan"} />
      {openDialog?.openMessageDialog && (
        <DialogFormation
          openDialog={openDialog?.openMessageDialog}
          handleClose={handleCloseDialog}
          title={"Message to assignees"}
          actionConfig={
            <div className="modal-config-wrapper-with-back">
              <BackButton
                label={"Back"}
                onClick={() => {
                  handleBackState({ openAssignPlanDialog: true, openMessageDialog: false });
                }}
                color={tokens.Text.General.Color}
                isButtonVisible={true}
              ></BackButton>
              <Button
                label="Next"
                onClick={() => {
                  setOpenDialog({ openMessageDialog: false, openconfirmDialog: true });
                }}
              />
            </div>
          }
        >
          <Grid
            container
            justifyContent="flex-start"
            display={"flex"}
            flexDirection="column"
            marginTop={"20px"}
            paddingRight={"15px"}
            gap={"20px"}
          >
            <Box width={isMobileScreen ? "100%" : "70%"}>
              <Typography variant={"body2"} color={tokens.Text.General.PrimaryBody}>
                Use this space to leave any message or direction to the assignees that'll receive the plan.
              </Typography>
            </Box>
            <Grid item width={"100%"}>
              <RichText
                minHeight="237px"
                placeholder="Start writing your message"
                initialValue={message}
                handleChangeUpdate={(message) => setMessage(message || null)}
              />
            </Grid>
          </Grid>
        </DialogFormation>
      )}
      {openDialog?.openconfirmDialog && (
        <DialogFormation
          openDialog={openDialog?.openconfirmDialog}
          handleClose={handleCloseDialog}
          title="Assignment Confirmation"
          actionConfig={
            <div className="modal-config-wrapper-with-back">
              <BackButton
                label={"Back"}
                onClick={() => {
                  setOpenDialog({ openMessageDialog: true, openconfirmDialog: false });
                }}
                color={tokens.Text.General.Color}
                isButtonVisible={true}
              ></BackButton>
              <Button label="Assign" onClick={handleAssignPlan} />
            </div>
          }
        >
          <Grid
            container
            marginTop={"20px"}
            justifyContent="flex-start"
            display={"flex"}
            flexDirection="column"
            paddingRight={"15px"}
            gap={"20px"}
          >
            <div className="selected-plan-section">
              <Typography variant={"body2"} showBold color={tokens.Text.General.PrimaryBody} className="p-absolute">
                Selected Plan
              </Typography>
              <Typography
                variant={"body2"}
                showBold
                color={tokens.Text.General.PrimaryBody}
                className="due-date-heading"
              >
                Due date
              </Typography>
            </div>
            <Grid gap={"8px"} display={"flex"} flexDirection={"column"} item overflow="hidden">
              {plansList?.map((plan: any) => {
                return (
                  <Grid
                    alignItems={""}
                    display={"flex"}
                    flexDirection={isMobileScreen ? "column" : "row"}
                    item
                    key={plan?.id}
                    className={!isSeeAll ? "hidden-date" : ""}
                  >
                    <Grid sm={8} display="flex" flexDirection={"row"} height="42px" alignItems={"center"} gap={2}>
                      <Article />
                      <Typography variant={"body2"} color={tokens.Icon.General.Primary}>
                        {plan?.name}
                      </Typography>
                    </Grid>
                    <Grid
                      xs={12}
                      sm={4}
                      sx={{ marginLeft: isMobileScreen ? "0px" : "auto" }}
                      display="flex"
                      flexDirection="row"
                      item
                    >
                      <Calender
                        sx={{ marginLeft: isMobileScreen ? "0px" : "70px", width: isMobileScreen ? "100%" : "auto" }}
                        showLable={isMobileScreen}
                        buttonView={false}
                        defaultValue={
                          plan?.brandDeadlines?.length ? plan?.brandDeadlines?.[0]?.["deadline"] : plan?.dueDate
                        }
                        onChange={(val: any) => addDueDate(plan.id, val)}
                      />
                    </Grid>
                  </Grid>
                );
              })}
              {plansList?.length > 2 && (
                <div className="date-collapse" onClick={handleCollapse}>
                  <Typography
                    variant="body2"
                    color="#4D4745;
"
                  >
                    {!isSeeAll ? translate("common.seeAll") : translate("common.seeLess")}
                  </Typography>
                  {!isSeeAll ? <ArrowDown /> : <ArrowUp />}
                </div>
              )}
            </Grid>

            <Typography variant={"body2"} showBold color={tokens.Text.General.PrimaryBody}>
              Assign to
            </Typography>
            <Typography variant={"body2"} color={tokens.Text.General.PrimaryBody} sx={{ mt: "-16px" }}>
              {translate("dashboard.AboveProperty.assignmentSummary")}
            </Typography>
            <Grid
              item
              width={"100%"}
              padding={"15px"}
              borderRadius={"12px"}
              border={`1px solid ${tokens.Border.General.Tertiary}`}
              maxHeight="305px"
              overflow="auto"
            >
              <Typography variant={"body2"} color={tokens.Icon.General.Primary}>
                {selectedInnCodeGroup?.name}
              </Typography>
              {selectedList?.map((item: any) => {
                return (
                  <Grid
                    key={item?.id}
                    marginTop={"15px"}
                    gap={"8px"}
                    alignItems={"center"}
                    display={"flex"}
                    flexDirection={"row"}
                    item
                  >
                    <UserCircle />
                    <Typography variant={"body2"} color={tokens.Text.General.PrimaryBody}>
                      <Typography component="span" showBold variant={"body2"}>
                        {item?.innCode || item?.innCodes?.join(",")}
                      </Typography>{" "}
                      -{" "}
                      {smeUsers?.filter((u: any) => u.hltId === item?.hltId)[0]?.displayName ||
                        users?.filter((u: any) => u.hltId === item?.hltId)[0]?.displayName ||
                        item?.displayName}
                    </Typography>
                  </Grid>
                );
              })}
            </Grid>
            <Divider />
            <Typography showBold variant={"body2"} color={tokens.Text.General.PrimaryBody}>
              Message for assignees
            </Typography>
            <Grid
              item
              width={"100%"}
              padding={"10px 20px"}
              borderRadius={"12px"}
              border={`1px solid ${tokens.Border.General.Tertiary}`}
              marginBottom="16px"
            >
              <HTMLRenderer content={message} />
            </Grid>
          </Grid>
        </DialogFormation>
      )}
      {openDialog?.openCompletedDialog && (
        <DialogFormation
          openDialog={openDialog?.openCompletedDialog}
          handleClose={handleCloseDialog}
          title="Plan Assigned"
          actionConfig={
            <div className="modal-config-wrapper">
              <Button label="Close" onClick={handleCloseDialog} />
            </div>
          }
        >
          <DialogContent>
            <div>
              <div>
                <Typography variant="body1" sx={{ color: tokens.Text.General.PrimaryBody, textAlign: "center" }}>
                  {messages.assignPlanConfirmation}{" "}
                </Typography>
              </div>
            </div>
          </DialogContent>
          <DialogActions></DialogActions>
        </DialogFormation>
      )}
    </>
  );
}
